<form *ngIf="data" #form="ngForm" submittable (ngSubmit)="onSubmit(form)">
    <contact-field #contactField
                   name="contacts"
                   [noEdit]="!data.isCanEdit"
                   (update)="update({contacts: form.value.contacts})"
                   (reset)="resetPhones($event)"
                   [ngModel]="contacts">
    </contact-field>

    <hr>

    <input-field name="address"
                 [title]="'Address'"
                 [noEdit]="!data.isCanEdit"
                 (update)="update({address: form.value.address})"
                 [ngModel]="data.address">
    </input-field>

    <input-field name="postalCode"
                 [title]="'Postal Code'"
                 [noEdit]="!data.isCanEdit"
                 (update)="update({postalCode: form.value.postalCode})"
                 [ngModel]="data.postalCode">
    </input-field>

    <input-field *ngIf="propertyService.account.isUserAdmin()"
                 name="purpose"
                 [title]="'Purpose'"
                 (update)="update({purpose: form.value.purpose ? form.value.purpose : null})"
                 [ngModel]="data.purpose">
    </input-field>

    <hr *ngIf="propertyService.account.isUserAdmin()">

    <select-field *ngIf="propertyService.account.isUserAdmin()"
                  name="companyId"
                  [title]="'Property Mgmt'"
                  [data]="propertyService.companies"
                  [noEdit]="!data.isCanEdit"
                  (update)="update({companyId: form.value.companyId, companyName: getCompanyNameById(form.value.companyId)})"
                  [ngModel]="data.companyId">
    </select-field>

    <hr>

    <search-select-field *ngIf="propertyService.account.isUserAdmin()"
                         name="corporationNumber"
                         [title]="'Corporation #'"
                         [data]="propertyService.corporationNumberListSearchSelect"
                         [noEdit]="!data.isCanEdit"
                         (update)="update({corporationNumber: form.value.corporationNumber})"
                         [ngModel]="data.corporationNumber ? data.corporationNumber.id : null">
    </search-select-field>

    <input-field name="propertyType"
                 [value]="data.propertyType"
                 [title]="'Property Type'"
                 [noEdit]="!data.isCanEdit"
                 [ngModel]="data.propertyType"
                 (update)="update({propertyType: form.value.propertyType})">
    </input-field>

    <select-field *ngIf="propertyService.account.isUserAdmin()"
                  name="timezone"
                  [title]="'Timezone'"
                  [data]="propertyService.timezoneList"
                  [noEdit]="!data.isCanEdit"
                  (update)="update({timezone: form.value.timezone})"
                  [ngModel]="data.timezone ? data.timezone.id : ''">
    </select-field>

    <input-field name="createdAt"
                 [value]="data.createdAt ? propertyService.transformDate(data.createdAt) : '-'"
                 [noEdit]="true"
                 [title]="'Date Of Incorp'">
    </input-field>

    <input-field name="numberOfUnits"
                 [noEdit]="true"
                 [title]="'# Of Units'"
                 [value]="data.numberOfUnits">
    </input-field>

    <input-field name="numberOfResidents"
                 [noEdit]="true"
                 [title]="'# Of Residents'"
                 [value]="data.numberOfResidents">
    </input-field>

    <input-field name="numberOfUsers"
                 [noEdit]="true"
                 [title]="'# Of Users'"
                 [value]="data.numberOfUsers">
    </input-field>

    <input-field name="numberOfEmails"
                 [noEdit]="true"
                 [title]="'# Of Emails'"
                 [value]="data.numberOfEmails">
    </input-field>

    <input-field name="numberOfInvitations"
                 [noEdit]="true"
                 [title]="'# Of Invitations'"
                 [value]="data.numberOfInvitations">
    </input-field>

    <div class="m-b-sm">
        <span class="mtv-primary-color clickable-text" (click)="propertyService.isWelcomeModalShow = true">
            Welcome message
        </span>
    </div>

    <div class="m-b-sm">
        <span class="mtv-primary-color clickable-text" (click)="propertyService.isInvitationEmailModalShow = true">
            Invitation Email
        </span>
    </div>

    <div class="m-b-sm">
        <span class="mtv-primary-color clickable-text" (click)="propertyService.contactUsModalShow = true">
            Contact Us
        </span>
    </div>

    <div class="m-b-xs">
        <span class="mtv-primary-color">Background image</span>
    </div>

    <div class="background-box" [ngClass]="{'loading': spinnerBackground}">
        <label>
            <input class="hidden" type="file" (change)="changeBackground($event)" accept="image/jpeg, image/png">
            <img [src]="propertyService.currentBackgroundIMG || '/assets/img/default-background.png'"/>
            <spinner [spinnerShow]="spinnerBackground"></spinner>
        </label>
    </div>

    <div class="m-t-xs">
        <label class="mtv-primary-color" (click)="removeBackground($event)">Delete</label>
    </div>

    <div class="m-t-sm">
        <agm-map [latitude]="data.latitude || 43.653226"
                 [longitude]="data.longitude || -79.3831843"
                 [zoom]="16"
                 [fullscreenControl]="false"
                 [streetViewControl]="false"
                 (mapClick)="placeMarker($event)" (mapDblClick)="mapDblClick()">
            <agm-marker [latitude]="data.latitude" [longitude]="data.longitude"></agm-marker>
        </agm-map>
    </div>
    <div class="m-t-xs">
        <label *ngIf="data.address" class="mtv-primary-color" (click)="resetMapCoordinates()">
            Reset
        </label>
    </div>

    <div class="m-t-xs">
        <div class="pull-right">
            <button title="Edit Theme" (click)="propertyService.customThemeModalShow = true" type="button" class="btn btn-white btn-xs"><i class="fa fa-pencil-square-o"></i></button>
            <button title="Delete Theme" *ngIf="theme" type="button" class="btn btn-white btn-xs" (click)="removeCustomTheme()"><i class="fa fa-trash-o"></i></button>
        </div>
        <h3>Building Theme</h3>
        <div class="building-custom-theme m-t-md" *ngIf="theme">

            <div class="square-logo"><img *ngIf="theme.logo" [src]="theme.logo"></div>

            <div class="m-b-xs">
                <div class="color-view" [style.background]="theme.colors.body"></div>
                <span class="strong">Background color</span>
            </div>

            <div class="m-b-xs">
                <div class="color-view" [style.background]="theme.colors.primary"></div>
                <span class="strong">Primary color</span>
            </div>

            <div class="m-b-xs">
                <div class="color-view" [style.background]="theme.colors.primaryHover"></div>
                <span class="strong">Primary hover color</span>
            </div>

            <div class="m-b-xs">
                <div class="color-view" [style.background]="theme.colors.menuBackgroundColor"></div>
                <span class="strong">Menu Background Color</span>
            </div>

            <div class="m-b-xs">
                <div class="color-view" [style.background]="theme.colors.menuFontColor"></div>
                <span class="strong">Menu Font Color</span>
            </div>

            <div class="m-b-xs">
                <div class="color-view" [style.background]="theme.colors.selectedMenuItemFontColor"></div>
                <span class="strong">Selected Menu Item Font Color</span>
            </div>
        </div>
    </div>

</form>




// WEBPACK FOOTER //
// /app/src/app/views/admin/property/item-view/property-info-view/property-info-view.component.html